/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-06 13:58:42
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-09-02 14:48:24
 * @FilePath: /unifyxp-v2-store-portal/src/store/constants.ts
 */
export enum EnumReducers {
  salesChannelContent = 'salesChannelContent',
  salesChannelProducts = 'salesChannelProducts',

  SalesChannelVersionContent = 'SalesChannelVersionContent',
  simpleProduct = 'simpleProduct',
  productSet = 'productSet',
  salesChannelLegal = 'salesChannelLegal',
  storeProduct = 'storeProduct',
  storeProductReview = 'storeProductReview',
  searchListPageSearchConditions = 'searchListPageSearchConditions',
  salesChannelCategory = 'salesChannelCategory',
  productCollection = 'productCollection',
  salesChannelCollection = 'salesChannelCollection',
  salesChannelCollectionEdit = 'salesChannelCollectionEdit',
  siderErrorSet = 'siderErrorSet',
  salesChannelLanguageSelect = 'salesChannelLanguageSelect',
  configProvider = 'configProvider',
  storeSettingTaxList = 'storeSettingTaxList',
  currentSalesChannel = 'currentSalesChannel',
  currentDatabase = 'currentDatabase',
  salesChannelDiscountsFlashSale = 'salesChannelDiscountsFlashSale',
  salesChannelDiscountsGiftPurchase = 'salesChannelDiscountsGiftPurchase',
  SalesChannelDiscountsDirectDiscount = 'SalesChannelDiscountsDirectDiscount',
  salesChannelDiscountsSubscriptionBuy = 'salesChannelDiscountsSubscriptionBuy',
  nativeSalesChannelTypeSelector = 'nativeSalesChannelTypeSelector',
  responsivePreviewSize = 'responsivePreviewSize',
  responsiveLayerEditor = 'responsiveLayerEditor',
}
